import { useLayoutEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

type ItemImageProps = {
    url?: string
    alt?: string
    className?: string
}

/** Square artwork that fades in, holding a pulse placeholder until the bytes land. */
export const ItemImage = ({ url, alt = '', className = undefined }: ItemImageProps) => {
    const [loaded, setLoaded] = useState(false)

    useLayoutEffect(() => setLoaded(false), [url])

    return (
        <div className={twMerge('w-full h-full', !loaded && 'bg-white/10 animate-pulse', className)}>
            {url && (
                <img
                    src={url}
                    alt={alt}
                    loading='lazy'
                    onLoad={() => setLoaded(true)}
                    className={twMerge(
                        'w-full h-full object-contain opacity-0',
                        loaded && 'opacity-100 transition-opacity duration-500'
                    )}
                />
            )}
        </div>
    )
}
